import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions";
import { defaultState } from "./report-model";

export const { Types, Creators } = createActions({
  reportShowLoading: [],
  reportHideLoading: [],
  reportShowLoadingRegisters: [],
  reportHideLoadingRegisters: [],
  reportMovementsShowLoading: [],
  reportMovementsHideLoading: [],
  reportMovementsShowLoadingRegisters: [],
  reportMovementsHideLoadingRegisters: [],
  reportFetchRegister: ["items", "totalItems", "inboundDocumentsTypes", "outboundDocumentsTypes"],
  reportMovementFetchRegister: ["movementItems", "movementTotalItems"],
  reportChangeFieldValue: ["fieldName", "value"],
  reportMovementChangeFieldValue: ["fieldName", "value"],
  reportFetchAsync: ["body"],
  reportFetchRegisterAsync: ["body"],
  reportMovementsFetchRegisterAsync: ["body"],
  reportMovementFetchAsync: ["body"],
});

export const showLoading = (state = defaultState) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state = defaultState) => ({
  ...state,
  isLoading: false,
});

export const showLoadingReportRegisters = (state = defaultState) => ({
  ...state,
  isLoadingRegisters: true,
});

export const hideLoadingReportRegisters = (state = defaultState) => ({
  ...state,
  isLoadingRegisters: false,
});

export const showLoadingMovements = (state = defaultState) => ({
  ...state,
  isLoadingMovements: true,
});

export const hideLoadingMovements = (state = defaultState) => ({
  ...state,
  isLoadingMovements: false,
});

export const showLoadingReportMovementsRegisters = (state = defaultState) => ({
  ...state,
  isLoadingMovementsRegisters: true,
});

export const hideLoadingReportMovementsRegisters = (state = defaultState) => ({
  ...state,
  isLoadingMovementsRegisters: false,
});

export const fetchReport = (state, { items, totalItems, inboundDocumentsTypes, outboundDocumentsTypes }) => ({
  ...state,
  isLoading: false,
  items,
  totalItems,
  inboundDocumentsTypes,
  outboundDocumentsTypes,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filter: onChangeFieldValue(state.filter, fieldName, value),
});

export const movementChangeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  movementFilter: onChangeFieldValue(state.movementFilter, fieldName, value),
});

export const fetchMovementReport = (state, { movementItems, movementTotalItems }) => ({
  ...state,
  isLoadingMovements: false,
  movementItems,
  movementTotalItems,
});

export default createReducer(defaultState, {
  [Types.REPORT_SHOW_LOADING]: showLoading,
  [Types.REPORT_HIDE_LOADING]: hideLoading,
  [Types.REPORT_SHOW_LOADING_REGISTERS]: showLoadingReportRegisters,
  [Types.REPORT_HIDE_LOADING_REGISTERS]: hideLoadingReportRegisters,
  [Types.REPORT_MOVEMENTS_SHOW_LOADING]: showLoadingMovements,
  [Types.REPORT_MOVEMENTS_HIDE_LOADING]: hideLoadingMovements,
  [Types.REPORT_MOVEMENTS_SHOW_LOADING_REGISTERS]: showLoadingReportMovementsRegisters,
  [Types.REPORT_MOVEMENTS_HIDE_LOADING_REGISTERS]: hideLoadingReportMovementsRegisters,
  [Types.REPORT_FETCH_REGISTER]: fetchReport,
  [Types.REPORT_MOVEMENT_FETCH_REGISTER]: fetchMovementReport,
  [Types.REPORT_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.REPORT_MOVEMENT_CHANGE_FIELD_VALUE]: movementChangeFieldValue,
});
